<template>
  <div
      class="sidebar sidebar-custom"
      :data-color="activeColor"
      :data-background-color="backgroundColor"
  >
    <!--left-content-->
    <div class="sidebar-workplace">
      <md-list-item class="cursor-pointer workplace-icon" v-popover:tooltip.right="'Bảng tin'"
                    v-bind:class="tab === 'workplace' ? 'icon-active' : ''"
                    v-on:click="changeMenu('workplace')">
        <i class="material-icons social-network background-no-repeat"></i>
      </md-list-item>
      <md-list-item class="cursor-pointer workplace-icon" v-popover:tooltip.right="'Trò chuyện'"
                    v-bind:class="tab === 'messenger' ? 'icon-active' : ''"
                    v-on:click="changeMenu('messenger')">
        <i class="material-icons chat background-no-repeat"></i>
        <md-badge v-if="$store.state.chat.unCountChatRead > 0" :md-content="$store.state.chat.unCountChatRead"></md-badge>
      </md-list-item>
      <md-list-item class="cursor-pointer workplace-icon" v-popover:tooltip.right="'Sơ đồ tổ chức'"
                    v-if="canAccessAdvancedWorkplace"
                    v-bind:class="tab === 'company-structure' ? 'icon-active' : ''"
                    v-on:click="changeMenu('company-structure')">
        <i class="material-icons company-structure background-no-repeat"></i>
      </md-list-item>

      <md-list-item class="cursor-pointer workplace-icon" v-popover:tooltip.right="'Quản lý nội bộ'"
                    v-if="canAccessAdminSettings"
                    v-bind:class="tab === 'admin-settings' ? 'icon-active' : ''"
                    v-on:click="changeMenu('admin-settings')">
        <i class="material-icons admin-settings background-no-repeat"></i>
      </md-list-item>


<!--      <img v-popover:avatars.right :src="user.avatar_url ? user.avatar_url : '/img/profile/avatar.png'"-->
<!--           class="group-image avatar cursor-pointer" id="mySettingBtn"/>-->
      <div class="link-to-email" v-popover:tooltip.right="'Mở quản lý email nội bộ'">
        <a href="https://mail.hostinger.com/v2/mailboxes/INBOX" target="_blank">
          <img src="/img/email.svg" alt="logo">
        </a>
      </div>
      <image-template
        v-popover:avatars.right
        class="group-image avatar cursor-pointer"
        id="mySettingBtn"
        :size="'small'"
        :image="user.avatar_url"
        :thumbnail="user.thumbnail"
        :name="user.fullname || user.username"
      />
      <popover name="avatars" class="sidebar-account-popover">
        <md-list class="p-0px popover-avatar">
          <md-list-item class="profile" @click="redirectToProfile">
            <md-avatar>
              <image-template
                :class="'pop-avatar-avatar'"
                :size="'small'"
                :image="user.avatar_url"
                :thumbnail="user.thumbnail"
                :name="user.fullname || user.username"
              />
            </md-avatar>
            <div class="md-list-item-text">
              <div class="">
                <div class="fullname">{{ user.fullname }}</div>
                <div class="text-300-default neutral_2">
                  Xem trang cá nhân
                </div>
              </div>
            </div>
          </md-list-item>
          <md-list-item @click="openBugReport">
            <md-icon>bug_report</md-icon>
            <span class="md-list-item-text">Báo cáo lỗi</span>
          </md-list-item>
          <md-list-item v-on:click="logout()">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Đăng xuất</span>
          </md-list-item>
        </md-list>
      </popover>
    </div>

  </div>
</template>
<script>
import Cookies from "js-cookie";
import AuthService from "../../../store/services/AuthService";
import NotificationService from "../../../store/services/NotificationService";
import ImageTemplate from "../../../components/ImageTemplate";
import {GROUP_CHAT_TYPE} from "../../../const/const";

export default {
  name: "sidebar",
  components: {ImageTemplate},
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      };
    }
  },
  watch: {
    '$route'(to, from) {
      this.router_name = to.name
      this.tab = to.meta.tab || 'workplace'
      this.$emit("change-menu", this.tab);
    },
    '$store.state.chat.unCountChatRead'(newV) {
      this.unCountChatRead = newV;
    },
    '$store.state.auth.user'(newV) {
      this.user = newV;
    },
    '$store.state.chat.dataSocket'(newV) {
      if (!newV || typeof newV !== 'object') return;
      const groupId = newV.group_id != null ? newV.group_id : (newV.group && newV.group.id);
      if (groupId == null) return;
      const off = newV.user_notification_off || [];
      const notViewingThisChat =
        this.$route.name !== 'messenger'
        || String(this.$route.params.messenger_id) !== String(groupId);
      const notificationsOn = off.indexOf(this.user.id) === -1;
      if (!notViewingThisChat || !notificationsOn) return;
      if (newV.sender && newV.sender.id !== this.user.id) {
        this.updateTitlePage(newV);
      }
    },
    '$store.state.chat.dataReactionEmoji'(newV) {
      if(newV.sender.id == this.user.id && newV.sender.id !== newV.user_reacted.id){
        newV.scroll_to_id = true;
        this.$store.dispatch("alerts/chatNotiReaction", newV);
      }
    },
    '$store.state.chat.reconnectSocket'(newV, oldV){
      if (!newV || newV.ts === oldV?.ts) return;
      this.$store.dispatch('chat/getUnreadGroupChat');
    },
    activeTab(newV) {
      this.tab = newV || 'workplace';
    },
  },
  props: {
    activeColor: {
      type: String,
      default: "green",
    },
    backgroundImage: {
      type: String,
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    activeTab: {
      type: String,
      default: "workplace"
    }
  },
  created() {
    this.$sidebar.toggleMinimize();
    this.tab = this.activeTab || this.$route.meta.tab || 'workplace';
    this.getUnreadCount();
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      tab: 'workplace',
      unCountRead: 0,
      unCountChatRead: 0,
    }
  },
  computed: {
    /** Menu nâng cao (Thư viện, Sơ đồ tổ chức, Quản lý nội bộ, WIKI) — company_access=full hoặc super admin. */
    canAccessAdvancedWorkplace() {
      const u = this.$store.state.auth.user || {};
      return String(u.company_access || "") === "full" || !!u.is_super_admin;
    },
    canAccessAdminSettings() {
      return Number(this.$store.state.auth.user?.id) === 119;
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },

    changeMenu(type) {
      this.tab = type;
      this.$emit("change-menu", type);
    },

    async logout() {
      const fcmToken = localStorage.getItem("cmf_token");
      Cookies.remove('access_token');
      Cookies.remove('user_id');
      await this.deleteAllCookies;
      await AuthService.logout({fcm_token: fcmToken})
      window.location.reload();
    },

    deleteAllCookies() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    },

    redirectToProfile() {
      this.$router.push('/profile/' + this.user.id);
      document.getElementById('mySettingBtn').click();
    },
    openBugReport() {
      const btn = document.getElementById('mySettingBtn');
      if (btn) btn.click();
      this.$modal.show('bug-report-modal');
    },

    getUnreadGroupChat() {
      this.$store.dispatch('chat/getUnreadGroupChat');
    },

    getUnreadCount() {
      NotificationService.getUnreadCount().then(res => {
        if (res.data) {
          this.unCountRead = res.data.count;
          this.$store.commit("updateUnCountRead", this.unCountRead)
        }
      });
    },
    updateTitlePage (data) {
      if (data.sender.id == this.user.id) return;
      let title = 'Agency Social';

      if (data.group.type === GROUP_CHAT_TYPE.USER){
        title = data.sender.fullname + ' đã nhắn tin cho bạn';
      }else{
        title = data.sender.fullname + ' đã nhắn tin vào ' + data.group.name;
      }

      document.title = title;
    },
  },

  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style lang="scss">
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.title-sidebar {
  margin: 10px 15px;
  font-size: 22px;
  font-weight: 600;
}

.subtitle-sidebar {
  margin: 22px 0 12px;
}
.link-to-email{
  position: absolute;
  bottom: 80px;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 26px !important;
  height: 26px !important;
  background-size: cover;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #FFFFFF;
}

.sidebar.sidebar-custom {
  width: 80px;
  overflow: visible;
}

.sidebar.sidebar-custom .sidebar-workplace {
  width: 80px !important;
}
</style>
